import Carousel from "react-bootstrap/Carousel";

function UncontrolledExample() {
  return (
    <Carousel>
      <Carousel.Item>
        <img className="d-block w-100" src="/main.jpg" alt="First slide" />
        <Carousel.Caption>
          <h1>당신을 성장시킬 벽</h1>
          <h3>6가지 벽에서 트레이닝을 시작해보세요</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src="/power2.jpg" alt="Second slide" />

        <Carousel.Caption>
          <h1>다채로운 문제들</h1>
          <h3>한달에 한 번, 국가대표 출신의 센터장님이 직접 셋팅합니다</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src="/power1.jpg" alt="Third slide" />

        <Carousel.Caption>
          <h1>뉴비는 더욱 환영합니다</h1>
          <h3>여러 선배님들이 여러분의 센터방문을 환영합니다</h3>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default UncontrolledExample;
